import { AppTitle } from "../AppTitle/AppTitle";
import MenuTrigger from "../Menu/MenuTrigger";
import EthButton from "../Modal/Buttons/AuthButtons/EthButtons/EthButton";
import TonDisconnectButton from "../Modal/Buttons/AuthButtons/TonButtons/TonDisconnectButton";
import SignOutButton from "../Modal/Buttons/AuthButtons/Web2Buttons/SignOutButton";
import { HeaderContainer } from "./HeaderContainer";
import { useTonWallet } from "@tonconnect/ui-react";
import React, { memo, useMemo } from "react";
import { useAccount } from "wagmi";

interface HeaderProps {
  username?: string;
  updateProfile: () => void;
}

const Header = ({ username, updateProfile }: HeaderProps) => {
  const wallet = useTonWallet();
  const { isConnected: isEthConnected } = useAccount();
  const isTonConnected = !!wallet;

  const authElement = useMemo(() => {
    if (isTonConnected) {
      return <TonDisconnectButton updateProfile={updateProfile} />;
    }

    if (username) {
      return (
        <SignOutButton username={username} updateProfile={updateProfile} />
      );
    }

    if (isEthConnected) {
      return <EthButton mainModalClose={() => {}} />;
    }

    return <MenuTrigger updateProfile={updateProfile} />;
  }, [isTonConnected, isEthConnected, username, updateProfile]);

  return (
    <HeaderContainer>
      <AppTitle />
      <div className="auth-buttons">{authElement}</div>
    </HeaderContainer>
  );
};

export default memo(Header);
